import { getRequest, postRequest, deleteRequest } from './util/requestAlias';
import { buildURL } from './util/requestHandler';
/**
 * 🔑删除一条通知
 *
 * 只要没有错误异常，无论是否有通知被删除，该接口都会返回成功。
 */
export const del = params => deleteRequest(buildURL('/notifications/{notification_id}', params));
/**
 * 🔑删除所有通知
 *
 * 只要没有错误异常，无论是否有通知被删除，该接口都会返回成功。
 */
export const deleteAll = (params = {}) => deleteRequest(buildURL('/notifications', params, ['type']));
/**
 * 🔑批量删除通知
 *
 * 只要没有错误异常，无论是否有通知被删除，该接口都会返回成功。
 */
export const deleteMultiple = params => deleteRequest(buildURL('/notifications/{notification_ids}', params));
/**
 * 🔑获取未读通知数量
 *
 * 获取未读通知数量。
 */
export const getCount = (params = {}) => getRequest(buildURL('/notifications/count', params, ['type']));
/**
 * 🔑获取通知列表
 *
 * 获取通知列表。
 */
export const getList = (params = {}) => getRequest(buildURL('/notifications', params, ['page', 'per_page', 'include', 'type', 'read']));
/**
 * 🔑把一条通知标记为已读
 *
 * 把一条通知标记为已读。
 */
export const read = params => postRequest(buildURL('/notifications/{notification_id}/read', params, ['include']));
/**
 * 🔑把所有通知标记为已读
 *
 * 只要没有错误异常。无论是否有通知被标记为已读，该接口都会返回成功。
 */
export const readAll = (params = {}) => postRequest(buildURL('/notifications/read', params, ['type']));
/**
 * 🔑批量把通知标记为已读
 *
 * 批量把通知标记为已读。
 */
export const readMultiple = params => postRequest(buildURL('/notifications/{notification_ids}/read', params, ['include']));